<template>
  <div class="container-warp">
    <Top-Nav pageTitle="待参加考试" @click-left="pageBack"></Top-Nav>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
      <van-cell-group inset v-for="item in list" :key="item.id" class="list-item">
        <div class="list-item-hd">{{ item.examName }}</div>
        <div class="list-item-bd">
          <p>考试类别：{{ item.examTypeNm }}</p>
          <p>考试状态：<span class="text-primary">{{ item.examStatus }}</span></p>
          <p>考试时间：{{ item.examTimeStart }}至{{ item.examTimeEnd }}</p>
        </div>
        <div class="list-item-foot">
          <van-button type="info" size="small" @click="jumpStartExam(item)" v-show="item.examStatus!='未开始'" icon="description-o">开始考试</van-button>
        </div>
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { chooseExamPaper, findPendingExam } from "@/api/exam.js";
export default {
  name: 'WaitExam',
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
    }
  },
  computed: {
    ...mapGetters(["userCode"]),
  },
  created() {
    this.handleChooseExamPaper()
  },
  methods: {
    async handleChooseExamPaper() {
      const params = { stuId: this.userCode }
      const { status } = await chooseExamPaper(params);
      if (status == 200) {
        this.onLoad()
      }
    },
    async onLoad() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        stuId: this.userCode,
        examMode: 0
      }
      // console.log(params)
      const { status, data } = await findPendingExam(params);
      if (status == 200) {
        let records = data.list || [];
        this.list.push(...records)
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    // 开始考试页面
    jumpStartExam(row) {// eslint-disable-line no-unused-vars
      console.log(row)
      // 考试前先验证人脸
      const examBefor = {// eslint-disable-line
        examId: row.id,
        examPaperId: row.paperId,
        examStuId: row.examStuId
      }
      webuni.redirectTo({ // eslint-disable-line
        url: `/pages/iplpsIndex/iplpsIndex?examBefor=${JSON.stringify(examBefor)}`
      })

      // this.$router.push({
      //   path: '/doExam',
      //   query: {
      //     examId: row.id,
      //     examPaperId: row.paperId,
      //     examStuId: row.examStuId
      //   }
      // })
    },
    pageBack() {
      this.$router.push({ path: '/index' })
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/list-style.less");

.list-item {
  .list-item-foot {
    display: flex;
    justify-content: center;
  }
}
</style>
